export interface DividerProps {
  className?: string;
  orientation?: 'vertical' | 'horizontal';
}

export const Divider = ({ className = '', orientation = 'horizontal' }: DividerProps) => {
  return (
    <div
      data-testid="divider"
      className={[
        'border border-t-0 border-l-0 border-solid border-[rgba(0,0,0,0.2)]',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
        className,
      ].join(' ')}
    >
      &nbsp;
    </div>
  );
};

export default Divider;
